import StyledLink from 'components/StyledLink';
import {
  ASSET_DETAILED_PATH,
  LOCATION_DETAILED_PATH,
  LOOSE_ITEM_DETAILED_PATH
} from 'constants/routeConstants';
import React from 'react';

const LocationContent = ({ location: { id, siteCode, deleted } }) => (
  <StyledLink isRedirectAvailable={!deleted} to={`${LOCATION_DETAILED_PATH}/${id}`}>
    {siteCode || ''}
  </StyledLink>
);

const AssetContent = ({ asset: { id, drCode } }) => (
  <StyledLink to={`${ASSET_DETAILED_PATH}/${id}`}>{drCode}</StyledLink>
);

const LooseItemContent = ({ looseItem: { id, name } }) => (
  <StyledLink to={`${LOOSE_ITEM_DETAILED_PATH}/${id}`}>{name}</StyledLink>
);

export const EntityContent = ({ reportEntity, location, asset, looseItem }) => {
  if (!reportEntity) return null;

  if (location?.id) return <LocationContent location={location} />;

  if (asset?.id) return <AssetContent asset={asset} />;

  if (looseItem?.id) return <LooseItemContent looseItem={looseItem} />;

  return null;
};
